import { memo, useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import ModalContext from 'contexts/ModalContext'

function PropertyGuestPublicRateSignUpCta() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const onClick = useCallback(async() => {
    await showModal<AccountAccessModalResult>(<AccountAccessModal />)
  }, [showModal])

  return <TextButton kind="secondary" size="large" onClick={onClick}>
    {intl.formatMessage({
      id: 'B3uDnzMAa0OEpQnQetbg',
      defaultMessage: 'Sign up for free',
      description: 'CTA button label for public(/B2C) rates shown to logged-out users, hinting that logging in may reveal cheaper non-public(/CUG) rates',
    })}
  </TextButton>
}

export default memo(PropertyGuestPublicRateSignUpCta)
